export function sortArticlesByItemName(a, b) {
  if (a.itemName === b.itemName)
    return a.productArticleId > b.productArticleId ? 1 : -1;

  const isEnglish = /^[A-Za-z]/; // Regex for names that start with A-Z
  const aIsEnglish = isEnglish.test(a.itemName);
  const bIsEnglish = isEnglish.test(b.itemName);

  // prioritize English names
  if (aIsEnglish && !bIsEnglish) return -1;
  if (!aIsEnglish && bIsEnglish) return 1;

  // If both are either English or then sort alphabetically
  return a.itemName.localeCompare(b.itemName, "sv", { sensitivity: "base" });
}
